// extracted by mini-css-extract-plugin
export default {"container":"table-detail-toolbar_container__C7CcL","button-container":"table-detail-toolbar_button-container__6-yyu","size-container":"table-detail-toolbar_size-container__cYgoP"};